import { on } from 'delegated-events'

const form = document.querySelector('.membership-form')
const amountSliderHolder = form ? form.querySelector('.amount-slider-holder') : null
const chargeField = form ? form.querySelector('[name=ChargeAmount]') : null
const membershipAmountField = form ? form.querySelector('#MembershipForm_MembershipForm_MembershipAmount') : null
const totalField = form ? form.querySelector('#membership-total-field') : null
const submitButton = form ? form.querySelector('[name=action_submit]') : null
const cardElement = document.getElementById('card-element')

const state = {
  stripe: null,
  stripeCard: null,
}

const fn = {
  init: () => {
    on('change', 'input[name=MembershipLevelID]', fn.handleLevelChange)

    fn.setupPayment()
  },

  handleLevelChange: (e) => {
    const option = e.target

    if (option.dataset.amountType === 'fixed') {
      fn.setTotal(option.dataset.amount)

      if (amountSliderHolder) {
        amountSliderHolder.classList.add('hidden')
      }
    }

    if (option.dataset.amountType === 'range') {
      fn.setTotal(option.dataset.amountMin)
      fn.setupAmountSlider(option.dataset.amountMin, option.dataset.amountMax)
    }
  },

  setupAmountSlider: (min, max) => {
    const slider = form.querySelector('input[type=range]')
    const marks = form.querySelector('.marks')
    const amountField = form.querySelector('input.membership-amount-field')
    const amountFieldError = form.querySelector('.membership-amount-field .form-field-description')

    const setAmount = (amount) => {
      if (parseInt(amount) < parseInt(min) || parseInt(amount) > parseInt(max)) {
        amountFieldError.classList.remove('hidden')
      } else {
        amountFieldError.classList.add('hidden')
        amountField.value = `$${amount}.00`

        fn.setTotal(amount)
      }
    }

    slider.setAttribute('min', min)
    slider.setAttribute('max', max)
    slider.value = min

    amountField.setAttribute('min', min)
    amountField.setAttribute('max', max)

    setAmount(min)

    marks.innerHTML = null

    const minMark = document.createRange().createContextualFragment(`
      <div class="mark is-active" data-value="${min}">
        $${min}
      </div>
    `)

    marks.appendChild(minMark)

    const fakeMarks = document.createRange().createContextualFragment(`
      <div class="fake-marks">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    `)

    marks.appendChild(fakeMarks)

    const maxMark = document.createRange().createContextualFragment(`
      <div class="mark" data-value="${max}">
        $${max}
      </div>
    `)

    marks.appendChild(maxMark)

    const handleSliderChange = (e) => {
      const amount = e.target.value
      const currentActive = marks.querySelector('.is-active')
      const nextActive = marks.querySelector(`[data-value="${amount}"]`)

      if (currentActive) {
        currentActive.classList.remove('is-active')
      }

      if (nextActive) {
        nextActive.classList.add('is-active')
      }

      setAmount(amount)
    }

    const handleAmountChange = (e) => {
      const value = e.target.value.replace('.00', '').replace('$', '')
      setAmount(value)

      slider.value = value

      const currentActive = marks.querySelector('.is-active')

      if (currentActive && parseInt(value) > min && parseInt(value) < max) {
        currentActive.classList.remove('is-active')
      }
    }

    slider.removeEventListener('input', handleSliderChange)
    amountField.removeEventListener('change', handleAmountChange)

    slider.addEventListener('input', handleSliderChange)
    amountField.addEventListener('change', handleAmountChange)

    amountSliderHolder.classList.remove('hidden')
  },

  setTotal: (amount) => {
    let formatCurrency = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'USD',
    })
    let total = (parseFloat(amount) + parseFloat(0.3)) / (1 - parseFloat(3.4) / 100)
    chargeField.value = total.toFixed(2)
    totalField.textContent = formatCurrency.format(total)
    membershipAmountField.value = amount
  },

  setupPayment: () => {
    if (cardElement) {
      state.stripe = window.Stripe(form.dataset.stripePubKey)
      fn.setupStripeCard()

      form.addEventListener('submit', fn.handleSubmit)

      on('click', '[formnovalidate]', () => {
        form.skipValidation = true
      })
    }
  },

  setupStripeCard: () => {
    const style = {
      base: {
        fontSize: '16px',
        fontFamily: 'Poppins, sans-serif',
        color: '#2c2c2c',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#b4b4b4',
        },
      },
      invalid: {
        color: '#b9112a',
      },
    }

    const card = state.stripe.elements().create('card', { style })

    card.mount('#card-element')
    state.stripeCard = card

    card.addEventListener('change', ({ error }) => {
      const displayError = document.getElementById('card-errors')
      if (error) {
        displayError.textContent = error.message
      } else {
        displayError.textContent = ''
      }
    })
  },

  handleSubmit: (e) => {
    if (e.target.skipValidation || e.target.forceSubmit) {
      return true
    }

    e.preventDefault()

    // Handle Stripe
    submitButton.disabled = true
    submitButton.classList.add('btn-loading')

    state.stripe
      .createToken(state.stripeCard, {
        name: form.querySelector('[name=CardholderName]').value,
      })
      .then((result) => {
        if (result.error) {
          const errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
          submitButton.disabled = false
        } else {
          fn.stripeTokenHandler(result.token)
        }
      })

    return false
  },

  stripeTokenHandler: (token) => {
    const formMessages = form.querySelector('.form-messages')
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeToken')
    hiddenInput.setAttribute('value', token.id)
    form.appendChild(hiddenInput)

    submitButton.disabled = true

    ajax
      .url(form.action)
      .body(new FormData(form))
      .post()
      .json((res) => {
        if (res.success) {
          form.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
        }

        if (res.message) {
          fn.showFormMessages(formMessages, res.message, res.success, false)
        }
      })
      .catch(() => {
        fn.showFormMessages(formMessages, 'Sorry, there was a problem with your submission')
      })
      .finally(() => {
        submitButton.disabled = false
      })
  },

  showFormMessages: (holder, message, success, autoHide) => {
    holder.style.display = 'block'
    holder.innerHTML = message

    if (success) {
      holder.classList.remove('form-message-error')
    } else {
      holder.classList.add('form-message-error')
    }

    if (autoHide) {
      setTimeout(() => {
        holder.style.display = 'none'
      }, 5000)
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-membershippage'),
  run: fn.init,
}
